"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RRP_ADD_PERMISSION = exports.RRP_ADD_PERMISSION = "RRP_ADD_PERMISSION";
var RRP_REMOVE_PERMISSION = exports.RRP_REMOVE_PERMISSION = "RRP_REMOVE_PERMISSION";
var RRP_CLEAR = exports.RRP_CLEAR = "RRP_CLEAR";